import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const SupportIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="-25 -25 300 300" {...rest} __css={styles}>
      <desc id="svgdescSalesSupport">Life Preserver Ring</desc>
      <path
        className="background"
        d="M127.5 0C57.2 0 0 57.2 0 127.5S57.2 255 127.5 255 255 197.8 255 127.5 197.8 0 127.5 0z"
      />
      <path
        className="accent"
        d="M127.9 198.4c-40.3 1.3-74.9-34-74.7-74.6.2-40.3 34.2-74.5 74.9-74.5 37.2.1 74.5 30.1 74.5 74.8 0 43.9-37.1 75.8-74.7 74.3zm-33.7-74.5c-.1 19 14.8 34.1 33.8 34.1 18.2.1 33.7-15.3 33.8-33.7.1-18.5-15.1-34-33.7-34.1-18.7-.2-33.8 14.8-33.9 33.7zM111.3 85c-.1-.2-.1-.4-.2-.6-2.8-6.8-5.7-13.7-8.5-20.5-.6-1.5-1.5-1.5-2.8-.9C84.9 70 74 80.9 67 95.7c-.8 1.7-.3 2.5 1.3 3.2 6.6 2.7 13.1 5.4 19.6 8.1 1.4.6 2.3.4 3.1-1.1 4.1-8.5 10.5-14.8 19-19 .6-.4 1.5-.7 1.3-1.9zM89 140.7l-.9.3c-6.7 2.8-13.5 5.6-20.2 8.3-2 .8-1.4 2-.8 3.3 6.9 14.5 17.7 25.2 32.1 32.2 1.9.9 2.9.6 3.7-1.4 2.6-6.5 5.3-12.9 8-19.3.6-1.5.4-2.4-1.1-3.1-8.5-4.2-14.8-10.6-19-19-.4-.6-.6-1.6-1.8-1.3zm100.4-43.9c-.1-.3-.2-.6-.4-.9-7.1-14.9-18-25.9-33-33-1.6-.7-2.3-.1-2.9 1.3-2.7 6.6-5.4 13.1-8.1 19.6-.6 1.4-.5 2.3 1 3.1 8.5 4.2 14.8 10.5 19 19 .6 1.3 1.4 1.8 2.8 1.1 6.6-2.8 13.3-5.5 19.9-8.3.9-.3 1.8-.6 1.7-1.9zm0 54.4c0-1.5-1.2-1.8-2.2-2.1-6.2-2.6-12.5-5.1-18.7-7.8-1.8-.8-2.8-.7-3.8 1.3-4 8.2-10.2 14.3-18.3 18.3-1.7.8-2.2 1.7-1.4 3.5 2.7 6.3 5.4 12.6 7.9 19 .9 2.2 1.9 2.4 3.9 1.4 14.3-7 24.9-17.6 31.9-31.9.3-.5.5-1.2.7-1.7z"
      />
    </Icon>
  );
};

export default SupportIcon;
